import { Injectable } from '@angular/core';
import { TableService } from '@app/modules/table/table.service';
import { Observable, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserListService extends TableService {
    className: string = 'UserListService';
    url: string = '/user/front_user';

    /**  Флаг поиска */
    isSearch: boolean = false;

    /**
     * Получение фильтров
     */
    public getFiltersList(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/fetch_filter_list', data, this._httpOptions);
    }

    /**
     * Получение записи
     * @param data данные
     */
    public getItem(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_item', data, this._httpOptions);
    }

    /**
     * Сохранение целой записи
     * @param data данные
     */
    public save(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save', data, this._httpOptions);
    }

    /**
     * Активация/деактивация учетной записи пользователя
     * @param data - id пользователя
     */
    public activateUser(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/activate_user', data, this._httpOptions);
    }

    /**
     * Сохранить аватар пользователя
     * @param data - данные фотографий
     */
    public savePhoto(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save_photo', data, this._httpOptions).pipe(take(1));
    }
    /**
     * Удалить аватар пользователя
     * @param data - данные фотографий
     */
    public removePhoto(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/remove_photo', data, this._httpOptions).pipe(take(1));
    }
    /**
     * Получить данные текущего пользователя
     */
    public getYourself(): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_yourself_data', {}, this._httpOptions);
    }
    /**
     * Получить данные текущего пользователя
     */
    public saveYourself(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save_yourself_data', data, this._httpOptions);
    }
}
